import React, { useEffect } from "react";
import { Field } from "formik";
import PropTypes from "prop-types";
import PublishSharpIcon from "@material-ui/icons/PublishSharp";
import { Button } from "@material-ui/core";
import clsx from "clsx";
import InputLabel from "@material-ui/core/InputLabel";
import InfoIcon from "@material-ui/icons/Info";
import Grid from "@material-ui/core/Grid";
import useStyles from "views/Styles/LoginStyles";
import HoverTooltip from "@Components/Tooltip/HoverTooltip";
import IconButton from "@material-ui/core/IconButton";
import { useTranslation } from "react-i18next";
import { GetApp } from "@material-ui/icons";

function FileDownload(props) {
  const { name, accept, label, required, buttonText, supportedTypes } = props;
  const { t } = useTranslation();
  const classes = useStyles(

  );
  

  let supportedTypeMessage;
  if (supportedTypes) {
    const modifiedSupportedTypes = supportedTypes.map((type) => `.${type}`);
    supportedTypeMessage = modifiedSupportedTypes.join(", ");
  }

  return (
    <Field name={name}>
      {(props) => {
        const { field, form, meta } = props;
        const { setFieldValue } = form;

        const downloadFile = () => {
          const link = document.getElementById("link");
          link.href = field.value;
          link.setAttribute("download", link.href);
        };

        useEffect(() => {
          downloadFile();
        }, [field.value]);

        const getFilename = () => {
          if (typeof field.value === "object") {
            return field.value.name;
          }
          return field.value.split("/").slice(-1)[0];
        };
        const fieldValue = field.value ? getFilename() : null;
        return (
          <>
            <InputLabel
              className={clsx(classes.label, {
                [classes.error]: meta.touched && meta.error,
              })}
            >
              <Grid container direction="row" alignItems="center">
                {label}
                {required ? <span style={{ color: "red" }}> *</span> : null}
                <HoverTooltip title={`${supportedTypeMessage}`}>
                  <IconButton style={{ padding: "0" }}>
                    <InfoIcon color="primary" />
                  </IconButton>
                </HoverTooltip>
              </Grid>
             
            </InputLabel>

            <div className="downloadButton" style={{ margin: "6px" }}>
              
              <label htmlFor={name}>
              <a id="link" target="_blank" download>

                <Button
                  style={{ textTransform: "capitalize" }}
                  variant="contained"
                  component="span"
                  color="primary"
                  startIcon={<GetApp />
                  
                }
                onClick={downloadFile}
                
                >
                  {buttonText ? t(buttonText) : t("Download")}
                </Button>
                  {fieldValue ? fieldValue : t("No File Selected")}
                </a>
              </label>
              <span
                className={
                  fieldValue ? classes.fileSelected : classes.fileNotSelected
                }
              >
                
              </span>
            </div>
          </>
        );
      }}
    </Field>
  );
}

FileDownload.propTypes = {
  name: PropTypes.string,
  accept: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  field: PropTypes.object,
  form: PropTypes.object,
  meta: PropTypes.object,
  buttonText: PropTypes.string,
  supportedTypes: PropTypes.array,
};

export default FileDownload;
